var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jobs-index _spread-out"},[_c('SwiperTabs',{attrs:{"swiper_items":[
      {
        label: _vm.$t('feeds.nav.lesson'),
        url: _vm.localePath(_vm.URLs.show_feeds_lesson),
      },
      {
        label: _vm.$t('feeds.nav.corps'),
        url: _vm.localePath(_vm.URLs.show_feeds_corps),
      },
      {
        label: _vm.$t('feeds.nav.seniors'),
        url: _vm.localePath(_vm.URLs.show_feeds_seniors),
        isHidden: !_vm.is_siginin,
      } ],"header-options":_vm.headerOption,"touchMove":false}},[_c('SwiperTabItem',[_c('ShowLessons',{attrs:{"is-active":_vm.tabIndex === 0}})],1),_c('SwiperTabItem'),_c('SwiperTabItem')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }